import { render, staticRenderFns } from "./backBillDialog.vue?vue&type=template&id=2223724a&"
import script from "./backBillDialog.vue?vue&type=script&lang=js&"
export * from "./backBillDialog.vue?vue&type=script&lang=js&"
import style0 from "./backBillDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports